var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-v-panel"},[_c('div',{staticClass:"k-v-panel-key"},[_vm._v("\n    "+_vm._s(_vm.label)+"：\n  ")]),_vm._v(" "),_c('div',{staticClass:"k-v-panel-value"},[_c('div',{staticClass:"k-v-panel-body"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }